import script from "./RecursiveObjects.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursiveObjects.vue?vue&type=script&setup=true&lang=js"

import "./RecursiveObjects.vue?vue&type=style&index=0&id=2a86613e&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a86613e"]])

export default __exports__